import { Link } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";

const NotFound = () => {
  const { darkMode } = useTheme();
  return (
    <div className={`min-h-screen flex items-center justify-center px-4 ${darkMode ? "bg-zinc-900" : "bg-gray-50"}`}>
      <div className="text-center max-w-md">
        <div className="text-6xl font-bold text-nomoz-orange mb-4">404</div>
        <h1 className={`text-2xl font-bold mb-2 ${darkMode ? "text-white" : "text-gray-900"}`}>
          Página não encontrada
        </h1>
        <p className={`mb-6 ${darkMode ? "text-gray-400" : "text-gray-600"}`}>
          O endereço que você acessou não existe ou foi movido.
        </p>
        <Link
          to="/"
          className="inline-block bg-nomoz-orange text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition"
        >
          Voltar ao início
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
